import { Component, OnInit } from "@angular/core";
import { Global } from "src/global";
import { ModalController } from "@ionic/angular";
import { AppService } from "src/app/app.service";

@Component({
  selector: "app-edit-lesson",
  templateUrl: "./editLesson.component.html",
  styleUrls: ["./editLesson.component.scss"],
})
export class EditLessonComponent implements OnInit {
  lesson: any;

  constructor(
    public globals: Global,
    public modalController: ModalController,
    private appservice: AppService
  ) {}

  dismissModal() {
    this.modalController.dismiss();
  }

  async onCopyLesson() {
    const data = { action: "CopyLesson" };
    await this.modalController.dismiss(data);
  }

  async closeModal() {
    await this.modalController.dismiss();
  }

  ngOnInit() {}
}
